<template>
  <v-app-bar app color="secondary" dark>
    <div class="d-flex align-center">
      <router-link :to="'/'">
        <v-img
          alt="App logo"
          class="shrink mr-2"
          contain
          :src="require('../../assets/logo.png')"
          transition="scale-transition"
          width="40"
        />
      </router-link>
      <router-link :to="'/'" color="white" dark>
        <v-toolbar-title v-html="title" class="white--text" />
      </router-link>
    </div>
    <v-spacer></v-spacer>
    <v-toolbar-items class="ml-4" v-if="isAuthenticated">
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn text small v-on="on">
            <span>
              {{ user.shortName }}
            </span>
            <v-icon class="ml-1">fas fa-caret-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <v-list-item-title>Профайл</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>Сменить пароль</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'logout' }">
            <v-list-item-title>Выйти</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar-items>
    <v-toolbar-items class="ml-4" v-else>
      <v-btn text small :to="{ name: 'login' }">
        <v-icon class="mr-1">fas fa-sign-in-alt</v-icon>
        Войти
      </v-btn>
    </v-toolbar-items>
    <template v-slot:extension v-if="isAuthenticated">
      <v-tabs centered grow>
        <v-tab :to="{ name: 'root' }">
          Тесты
        </v-tab>
        <v-tab :to="{ name: 'scores' }">
          Достижения
        </v-tab>
        <v-tab :to="{ name: 'rating' }">
          Рейтинг
        </v-tab>
      </v-tabs>
    </template>
  </v-app-bar>
</template>
<script>
import { mapGetters } from 'vuex'
import config from '../../config'
export default {
  data() {
    return {
      title: config.appTitle
    }
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'user'])
  }
}
</script>
